import { render, staticRenderFns } from "./default.vue?vue&type=template&id=734abbd4&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/Users/dominicelci/Projects/wayfx/growaov-dashboard/components/Header.vue').default,Nav: require('/Users/dominicelci/Projects/wayfx/growaov-dashboard/components/Nav.vue').default})
